import LoadingSpinner from "@/components/Loading/LoadingSpinner";

export const RouterLoading = () => <LoadingSpinner />;

export default RouterLoading;
